import { render, staticRenderFns } from "./LegalName.vue?vue&type=template&id=28995100&scoped=true"
import script from "./LegalName.vue?vue&type=script&lang=js"
export * from "./LegalName.vue?vue&type=script&lang=js"
import style0 from "./LegalName.vue?vue&type=style&index=0&id=28995100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28995100",
  null
  
)

export default component.exports